import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ModerationDetail } from '../types';
import { Field, TextBlock } from '../components/DetailField';

// Report summary (doc 09 §4.5). reason = category ?? userReportType ?? "Unknown"; useCase shows as
// "Additional Notes" (parity :248). Shared by USER / CONTENT / COMMENT / MESSAGE.
export function ReportSummaryCard({ report }: { report: ModerationDetail }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Report Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="divide-y">
          <Field label="Reason">{report.reason}</Field>
        </div>
        {report.description && <TextBlock label="Description" value={report.description} />}
        {report.useCase && <TextBlock label="Additional Notes" value={report.useCase} />}
      </CardContent>
    </Card>
  );
}
